// GenericModal.jsx
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const GenericModal = ({
  show,
  onHide,
  title,
  children,
  onConfirm,
  confirmText,
  cancelText,
}) => {
  const { t } = useTranslation("layout");
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <button type="button" className="button-default light" onClick={onHide}>
          {cancelText ?? t("genericModal.cancel")}
        </button>
        <button type="button" className="button-default" onClick={onConfirm}>
          {confirmText ?? t("genericModal.confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenericModal;
